import React, { useState } from 'react';
import {
  Modal,
  Box,
  TextField,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Fade,
  Backdrop,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import defaultImage from '../../Assets/images/image2.png';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 500,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const BannerModal = ({ open, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    linkUrl: '',
    displayOrder: '',
    isActive: false,
    imageFile: null,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });
    } else if (type === 'file') {
      setFormData({ ...formData, imageFile: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append('Name', formData.name);
    payload.append('ImageFile', formData.imageFile);
    payload.append('LinkUrl', formData.linkUrl || '');
    payload.append('DisplayOrder', formData.displayOrder || '');
    payload.append('IsActive', formData.isActive);

    onSubmit(payload);
    setFormData({
      name: '',
      linkUrl: '',
      displayOrder: '',
      isActive: false,
      imageFile: null,
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300 }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">Upload Image</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              name="name"
              label="Name *"
              value={formData.name}
              onChange={handleChange}
              required
              margin="normal"
            />
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              border="2px dashed #ccc"
              borderRadius="8px"
              p={2}
              my={2}
              textAlign="center"
              sx={{ cursor: 'pointer' }}
              onClick={() => document.getElementById('imageFileInput').click()}
            >
              <CloudUploadIcon sx={{ fontSize: 40, color: '#888' }} />
              <Typography variant="body2">
                Click or drag to upload image
              </Typography>
              <input
                type="file"
                id="imageFileInput"
                name="imageFile"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleChange}
                required
              />
              {formData.imageFile ? (
                <Typography variant="caption" mt={1}>
                  Selected: {formData.imageFile.name}
                </Typography>
              ) : (
                <Typography variant="caption" mt={1}>
                  No file chosen
                </Typography>
              )}
            </Box>

            <TextField
              fullWidth
              name="linkUrl"
              label="Link URL"
              value={formData.linkUrl}
              onChange={handleChange}
              margin="normal"
            />
            <TextField
              fullWidth
              type="number"
              name="displayOrder"
              label="Display Order"
              value={formData.displayOrder}
              onChange={handleChange}
              margin="normal"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="isActive"
                  checked={formData.isActive}
                  onChange={handleChange}
                />
              }
              label="Is Active"
            />

            <Box mt={3}>
              <Button type="submit" variant="contained" fullWidth>
                Submit
              </Button>
            </Box>
          </form>
        </Box>
      </Fade>
    </Modal>
  );
};

export default BannerModal;
